import { render, staticRenderFns } from "./ArticleCardSkeleton.vue?vue&type=template&id=924e04fc&"
import script from "./ArticleCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./ArticleCardSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports